import React, { useCallback, useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Button,
  ListGroup,
} from "react-bootstrap";
import {
  getCategory,
  getChats,
  getContracts,
  getIndividualChat,
  getSearchUser,
  getSubAdmins,
} from "../../services/Admin/adminServices";
import Pagination from "../components/Pagination";
import { AsyncPaginate } from "react-select-async-paginate";
const ChatPage = () => {
  const [chats, setChats] = useState([]);
  const [users, setUsers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemsPerPage] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [search, setSearch] = useState("");
  const [openChat, setOpenChat] = useState(false);
  const [selectedChat, setSelectedChat] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [openContract, setOpenContract] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [conversationId, setConversationId] = useState(null);
  const [showTitle,setShowTitle]=useState(false)
  const [selectedData, setSelectedData] = useState({
    category: "",
    user: "",
  });
  const [currentPage, setCurrentPage] = useState(0);

  // --- CHAT PAGINATION STATES ---
  const [chatPage, setChatPage] = useState(0);
  const [hasMoreChats, setHasMoreChats] = useState(true);
  
  // --- CONTRACT PAGINATION STATES ---
  const [contractPage, setContractPage] = useState(0);
  const [hasMoreContracts, setHasMoreContracts] = useState(true);
const [selectedUser, setSelectedUser] = useState(null);
  // Shared fetching state to prevent multiple API calls at once
  const [isFetchingHistory, setIsFetchingHistory] = useState(false);
  
  // Refs for scrolling
  const chatContainerRef = useRef(null);
  const prevScrollHeightRef = useRef(0);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

 const loadUsers = async (search, loadedOptions, { page }) => {
  const res = await getSearchUser(page, 10, "User",search);
 const count = res.data.data.total;
  return {
    options: res?.data?.data?.data.map((user) => ({
      value: user._id,
      label: `${user.name}${user.email ? ` (${user.email})` : ""}`,
    })),

    hasMore: (page + 1) * 10 < count,
    additional: {
      page: page + 1,
    },
  };
};
  useEffect(() => {
   
    if (openChat && !openContract && chatPage === 0 && !loading && selectedChat.length > 0) {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    }
    // Auto-scroll for Contracts: Only if NOT loading and we actually have contracts
    if (openChat && openContract && contractPage === 0 && !loading && contracts.length > 0) {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    }
  }, [openChat, openContract, selectedChat, contracts, chatPage, contractPage, loading]);  

  const getUserChats = useCallback(async () => {
    if (!selectedData.user) {
      setChats([]);
      return;
    }
    try {
      setLoading(true);
      const res = await getChats(
        currentPage,
        10,
        selectedData.user,
        debouncedSearch,
        selectedData.category,
      );
      setChats(res?.data?.data || []);
      setTotalItems(res?.data?.data.length);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [selectedData.category, selectedData.user, currentPage, debouncedSearch]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [search]);

  useEffect(() => {
    getUserChats();
    setOpenChat(false);
  }, [getUserChats]);

  

  const fetchCategories = async () => {
    try {
      const res = await getCategory(0, 100);
      setCategories(res?.data?.data?.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  // --- INDIVIDUAL CHAT FETCH ---
  const fetchIndividualChat = async (id, page = 0, isLoadMore = false) => {
    try {
      if (!isLoadMore) setLoading(true);
      else setIsFetchingHistory(true);

      const res = await getIndividualChat(id, page, 10);
      const fetchedMessages = res?.data?.data || [];

      if (fetchedMessages.length < 10) {
        setHasMoreChats(false);
      }

      if (isLoadMore) {
        if (chatContainerRef.current) {
          prevScrollHeightRef.current = chatContainerRef.current.scrollHeight;
        }

        setSelectedChat((prev) => [...prev, ...fetchedMessages]);

        setTimeout(() => {
          if (chatContainerRef.current) {
            const currentHeight = chatContainerRef.current.scrollHeight;
            chatContainerRef.current.scrollTop = currentHeight - prevScrollHeightRef.current;
          }
        }, 0);
      } else {
        setSelectedChat(fetchedMessages);
        setChatPage(0);
        setHasMoreChats(fetchedMessages.length === 10);
        setConversationId(id);
      }
    } catch (error) {
      console.error(error);
      if (!isLoadMore) setSelectedChat([]);
    } finally {
      setLoading(false);
      setIsFetchingHistory(false);
    }
  };

  // --- UPDATED CONTRACT FETCH ---
  const fetchContract = async (id, page = 0, isLoadMore = false) => {
    try {
      if (!isLoadMore) setLoading(true);
      else setIsFetchingHistory(true);

      const res = await getContracts(id, page, 10);
      const fetchedContracts = res?.data?.data?.contracts || [];

      if (fetchedContracts.length < 10) {
        setHasMoreContracts(false);
      }

      if (isLoadMore) {
        // Capture height before adding new contracts to DOM
        if (chatContainerRef.current) {
          prevScrollHeightRef.current = chatContainerRef.current.scrollHeight;
        }

        setContracts((prev) => [...prev, ...fetchedContracts]);

        // Adjust scroll position to prevent jumping
        setTimeout(() => {
          if (chatContainerRef.current) {
            const currentHeight = chatContainerRef.current.scrollHeight;
            chatContainerRef.current.scrollTop = currentHeight - prevScrollHeightRef.current;
          }
        }, 0);
      } else {
        setContracts(fetchedContracts);
        setContractPage(0);
        setHasMoreContracts(fetchedContracts.length === 10);
      }
    } catch (error) {
      console.error(error);
      if (!isLoadMore) setContracts([]);
    } finally {
      setLoading(false);
      setIsFetchingHistory(false);
    }
  };

 
  const handleChatScroll = (e) => {
    const { scrollTop } = e.target;
    
    // ADD !loading HERE so it ignores fake scroll events during the initial load
    if (scrollTop === 0 && !isFetchingHistory && !loading) {
      if (!openContract && hasMoreChats) {
        // Load more chats
        const nextPage = chatPage + 1;
        setChatPage(nextPage);
        fetchIndividualChat(conversationId, nextPage, true);
      } else if (openContract && hasMoreContracts) {
        // Load more contracts
        const nextPage = contractPage + 1;
        setContractPage(nextPage);
        fetchContract(conversationId, nextPage, true);
      }
    }
  };
  useEffect(() => {
    
    fetchCategories();
    setCurrentPage(0);
  }, []);

  const handleOpenChat = (id) => {
    setOpenChat(true);
    setChatPage(0); 
    setHasMoreChats(true);
    fetchIndividualChat(id, 0, false);
  };

  const handleContracts = () => {
    setShowTitle(true)
    setOpenContract(true);
    setContractPage(0); 
    setHasMoreContracts(true);
    fetchContract(conversationId, 0, false);
  };

  const handleBackToChats = () => {
    setOpenChat(false);
    setOpenContract(false);
    setSelectedChat([]);
    setCurrentPage(0);
    setChatPage(0);
    setContractPage(0);
    setShowTitle(false)
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <Container fluid className="p-4 min-vh-100">
      <h2 className="mb-4 fw-bold" style={{ color: "#64CAE5" }}>
        Chat Management
      </h2>

      <Row>
        {/* LEFT COLUMN: Controls */}
        <Col md={4}>
          <Card
            className="shadow-sm p-4 mb-4 border-0"
            style={{ borderRadius: "16px", background: "#64CAE5" }}
          >
            <h5 style={{ color: "black" }} className="mb-4 fw-bold ">
              Filters
            </h5>

            <Form.Group className="mb-4">
  <Form.Label className="fw-semibold text-black">
    Select User
  </Form.Label>

  <AsyncPaginate 
styles={{
    control: (provided, state) => ({
      ...provided,
      borderRadius: "16px",
      backgroundColor: "white",
     
     
      boxShadow: state.isFocused ? "0 0 0 1px #64CAE5" : "none",
      "&:hover": {
        borderColor: "#64CAE5"
      }
    }),
    // Optional: Changes placeholder text color to black for better contrast
    placeholder: (provided) => ({
      ...provided,
      color: "black"
    }),
    // Optional: Changes selected text color to black
    singleValue: (provided) => ({
      ...provided,
      color: "black"
    })
  }}
   value={selectedUser}
    loadOptions={loadUsers}
    additional={{
      page: 0,
    }}
    onChange={(option) => {
    setSelectedUser(option);

    setSelectedData((prev) => ({
      ...prev,
      user: option?.value || "",
      category: option ? prev.category : "",
    }));
  }}
    placeholder="Search user..."
    debounceTimeout={500}
    isClearable
  />
</Form.Group>

            <Form.Group>
              <Form.Label style={{ color: "black" }} className="fw-semibold">
                Select Category
              </Form.Label>
              <Form.Select
              className="shadow-none border-secondary-subtle bg-white"
                value={selectedData.category}
                onChange={(e) =>
                  setSelectedData({ ...selectedData, category: e.target.value })
                }
                disabled={!selectedData.user}
              >
                <option value="">-- All Categories --</option>
                {categories.map((vendor) => (
                  <option key={vendor._id} value={vendor._id}>
                    {vendor.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Card>
        </Col>

        <Col md={8}>
          <Card
            className="shadow-sm border-0 d-flex flex-column"
            style={{ height: "75vh", borderRadius: "16px" }}
          >
            <Card.Header
              className="bg-white py-3 d-flex align-items-center"
              style={{
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                borderTop: "2px solid #64CAE5",
              }}
            >
              {openChat &&
                (openContract ? (
                  <Button
                    variant="link"
                    onClick={() =>{ setOpenContract(false) 
                      setShowTitle(false)}}
                    className="p-0 me-3 text-decoration-none fw-bold"
                    style={{ color: "#0AB7EA" }}
                  >
                    &larr; Back
                  </Button>
                ) : (
                  <Button
                    variant="link"
                    onClick={handleBackToChats}
                    className="p-0 me-3 text-decoration-none fw-bold"
                    style={{ color: "#0AB7EA" }}
                  >
                    &larr; Back
                  </Button>
                ))}
              {openChat ? (
                showTitle ? "" : 
                <h5
                  className="m-0 fw-semibold"
                  onClick={handleContracts}
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                >
                  See Contracts
                </h5>
              ) : (
                <h5 className="m-0 fw-bold" style={{ color: "#333" }}>
                  Available Chats
                </h5>
              )}
            </Card.Header>

            <Card.Body
              ref={chatContainerRef}
              onScroll={handleChatScroll}
              className="overflow-auto "
              style={{
                borderBottomLeftRadius: "16px",
                borderBottomRightRadius: "16px",
                background: "#64CAE5",
              }}
            >
              {!selectedData.user ? (
                <div
                  style={{ color: "white" }}
                  className="text-center  mt-5 fw-medium"
                >
                  Please select a user to begin.
                </div>
              ) : openChat ? (
                openContract ? (
                  <>
                    {/* LOADING INDICATOR FOR CONTRACT HISTORY */}
                    {isFetchingHistory && (
                      <div className="text-center my-2 fw-bold" style={{ color: "white", fontSize: "12px" }}>
                        Loading older contracts...
                      </div>
                    )}

                    {loading && !isFetchingHistory ? (
                      <div
                        style={{ color: "white" }}
                        className="text-center  mt-5"
                      >
                        loading...
                      </div>
                    ) : contracts.length === 0 ? (
                      <div className="text-center text-muted mt-5">
                        No contracts in this conversation.
                      </div>
                    ) : (
                      <>
                        {[...contracts]
                          .sort(
                            (a, b) =>
                              new Date(a.createdAt) - new Date(b.createdAt),
                          )
                          .map((msg, index) => {
                            const isUser =
                              msg?.sender?._id === selectedData.user;
                            const messageTime = msg?.createdAt
                              ? new Date(msg.createdAt).toLocaleTimeString([], {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })
                              : "";

                            return (
                              <div
                                key={msg?._id || index}
                                className={`d-flex flex-column mb-3 ${
                                  isUser
                                    ? "align-items-start"
                                    : "align-items-end"
                                }`}
                              >
                                <small
                                  className="mb-1 fw-medium"
                                  style={{
                                    fontSize: "12px",
                                    color: "#555",
                                    padding: "0 10px",
                                  }}
                                >
                                  {msg?.sender?.name || "Unknown"}
                                </small>

                                <div
                                  style={{
                                    background: isUser ? "#fff" : "#0AB7EA",
                                    color: isUser ? "#333" : "#fff",
                                    padding: "14px 18px",
                                    borderRadius: "16px",
                                    borderBottomLeftRadius: isUser
                                      ? "4px"
                                      : "16px",
                                    borderBottomRightRadius: isUser
                                      ? "16px"
                                      : "4px",
                                    maxWidth: "65%",
                                    boxShadow: "0 3px 8px rgba(0,0,0,0.08)",
                                    border: isUser
                                      ? "1px solid #e0e0e0"
                                      : "none",
                                    fontSize: "14px",
                                    lineHeight: "1.6",
                                  }}
                                >
                                  <div>
                                    <strong> Date:</strong>{" "}
                                    {msg?.contract?.date
                                      ? new Date(
                                          msg.contract.date,
                                        ).toLocaleDateString("en-IN", {
                                          day: "numeric",
                                          month: "long",
                                          year: "numeric",
                                        })
                                      : "N/A"}
                                  </div>

                                  <div>
                                    <strong> Time:</strong>{" "}
                                    {msg?.contract?.time || "N/A"}
                                  </div>

                                  <div>
                                    <strong> Address:</strong>{" "}
                                    {msg?.contract?.address || "N/A"}
                                  </div>

                                  <div>
                                    <strong> Budget:</strong> ₹
                                    {msg?.contract?.budget || "N/A"}
                                  </div>

                                  <div>
                                    <strong> Description:</strong>
                                    <br />
                                    <span style={{ opacity: 0.9 }}>
                                      {msg?.contract?.description || "N/A"}
                                    </span>
                                  </div>

<div>
  <strong>Status:</strong>{" "}
  <span
    className={`badge ${
      msg?.contract?.status === "Approved"
        ? "bg-success"
        : msg?.contract?.status === "Pending"
        ? "bg-warning text-white"
        : msg?.contract?.status === "Rejected"
        ? "bg-danger"
        : "bg-secondary"
    }`}
  >
    {msg?.contract?.status  || "N/A"}
  </span>
</div>

                                </div>

                                <small
                                  className="mt-1"
                                  style={{
                                    fontSize: "10px",
                                    color: "#777",
                                    padding: "0 10px",
                                  }}
                                >
                                  {messageTime}
                                </small>
                              </div>
                            );
                          })}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {/* LOADING INDICATOR FOR MESSAGE HISTORY */}
                    {isFetchingHistory && (
                      <div className="text-center my-2 fw-bold" style={{ color: "white", fontSize: "12px" }}>
                        Loading older messages...
                      </div>
                    )}

                    {loading && !isFetchingHistory ? (
                      <div
                        style={{ color: "white" }}
                        className="text-center  mt-5"
                      >
                        loading...
                      </div>
                    ) : selectedChat.length === 0 ? (
                      <div className="text-center text-muted mt-5">
                        No messages in this conversation.
                      </div>
                    ) : (
                      <>
                        {[...selectedChat]
                          .sort(
                            (a, b) =>
                              new Date(a.messageTime) - new Date(b.messageTime),
                          )
                          .map((msg, index) => {
                            const isUser =
                              msg?.sender?._id === selectedData.user;
                            const messageTime = msg?.messageTime
                              ? new Date(msg.messageTime).toLocaleTimeString(
                                  [],
                                  {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                  },
                                )
                              : "";

                            return (
                              <div
                                key={msg?._id || index}
                                className={`d-flex flex-column mb-3 ${
                                  isUser
                                    ? "align-items-start"
                                    : "align-items-end"
                                }`}
                              >
                                <small
                                  className="mb-1 fw-medium"
                                  style={{
                                    fontSize: "12px",
                                    color: "#555",
                                    padding: "0 10px",
                                  }}
                                >
                                  {msg?.sender?.name || "Unknown"}
                                </small>

                                <div
                                  style={{
                                    background: isUser ? "#fff" : "#0AB7EA",
                                    color: isUser ? "#333" : "#fff",
                                    padding: "12px 18px",
                                    borderRadius: "20px",
                                    borderBottomLeftRadius: isUser
                                      ? "4px"
                                      : "20px",
                                    borderBottomRightRadius: isUser
                                      ? "20px"
                                      : "4px",
                                    maxWidth: "65%",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                                    border: isUser
                                      ? "1px solid #e0e0e0"
                                      : "none",
                                    fontSize: "15px",
                                  }}
                                >
                                  {msg?.message}
                                </div>

                                <small
                                  className="mt-1"
                                  style={{
                                    fontSize: "10px",
                                    color: "#777",
                                    padding: "0 10px",
                                  }}
                                >
                                  {messageTime}
                                </small>
                              </div>
                            );
                          })}
                      </>
                    )}
                  </>
                )
              ) : (
                <>
                  <div className="flex-grow-1">
                    <label
                      className="form-label mb-1"
                      style={{ fontSize: "12px" }}
                    ></label>
                    <input
                      type="text"
                      style={{
                        borderRadius: "0.5rem",
                        borderColor: "#64CAE5",
                        marginBottom: "20px",
                      }}
                      className="form-control w-100"
                      placeholder="Search by name"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  {loading ? (
                    <div
                      style={{ color: "white" }}
                      className="text-center mt-5"
                    >
                      Loading....
                    </div>
                  ) : chats.length === 0 ? (
                    <div className="text-center mt-5 text-white">
                      No active conversations found.
                    </div>
                  ) : (
                    <ListGroup variant="flush">
                      {chats.map((data, index) => (
                        <ListGroup.Item
                          key={index}
                          action
                          onClick={() => handleOpenChat(data?._id)}
                          className="d-flex justify-content-between align-items-center p-3 mb-2 rounded shadow-sm border-0"
                          style={{
                            cursor: "pointer",
                            transition: "0.2s ease",
                            backgroundColor: "white",
                          }}
                        >
                          <span className="fw-medium text-dark">
                            {data?.conversationName ||
                              `Conversation #${index + 1}`}
                          </span>
                          <span style={{ color: "#0AB7EA" }}>View &rarr;</span>
                        </ListGroup.Item>
                      ))}

                      <div className="card-footer clearfix mt-3">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
                          <div
                            className="dataTables_info mb-3 mb-md-0"
                            style={{ color: "#64CAE5" }}
                          ></div>
                          <div className="d-flex align-items-center">
                            {
                              <Pagination
                                pageCount={totalPages}
                                pageValue={currentPage}
                                setPage={setCurrentPage}
                              />
                            }
                          </div>
                        </div>
                      </div>
                    </ListGroup>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ChatPage;